export default __webpack_public_path__ + "static/media/map2.b257ed5d.png";